// https://fubotv.atlassian.net/wiki/spaces/PLAT/pages/1969160193/Error+Handling
import { ApiError } from '../../errors.js';
function toViolation(item) {
    return {
        field: item.field,
        messages: item.lc_messages,
    };
}
function toViolations(data) {
    if (!data)
        return;
    return data.map(toViolation);
}
function errFromString(message) {
    return new ApiError(400, message, 'Bad Request');
}
export function normalizeApiError(res) {
    if (res instanceof ApiError)
        return res;
    if (typeof res === 'string')
        return errFromString(res);
    const response = res && res.response ? res.response : res;
    const body = response.body;
    const code = body?.error?.code ?? '';
    const status = response?.status;
    const statusCode = status ? Number(status) : 400;
    const message = body?.error?.type ||
        body?.error?.lc_message ||
        body?.error?.message ||
        response?.message ||
        'Unknown Error';
    const violations = toViolations(body?.error?.violations?.list);
    const e = new ApiError(statusCode, message, code);
    if (violations)
        e.addViolations(violations);
    return e;
}
